<template lang="pug">
.organization-avatar(
  :style="containerStyle"
  @click="$emit('click')"
)
  img(
    v-if="avatarUrl"
    :src="avatarUrl"
    :alt="name"
  ).avatar-image
  .avatar-initials(v-else :style="initialsStyle") {{ initials }}
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { getInitials } from '../utils/glowPageUtils';

export default defineComponent({
  name: 'OrganizationAvatar',
  props: {
    name: {
      type: String,
      required: true,
    },
    avatarUrl: {
      type: String,
      default: null,
    },
    size: {
      type: Number,
      default: 48,
    },
    borderWidth: {
      type: Number,
      default: 2,
    },
    borderColor: {
      type: String,
      default: '#FFFFFF',
    },
  },
  emits: ['click'],
  setup(props) {
    const initials = computed(() => getInitials(props.name));

    const containerStyle = computed(() => ({
      width: `${props.size}px`,
      height: `${props.size}px`,
      border: `${props.borderWidth}px solid ${props.borderColor}`,
    }));

    const initialsStyle = computed(() => ({
      fontSize: `${props.size * 0.4}px`,
    }));

    return {
      initials,
      containerStyle,
      initialsStyle,
    };
  },
});
</script>

<style lang="scss" scoped>
.organization-avatar {
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e0e0e0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-initials {
  color: #424242;
  font-weight: bold;
  user-select: none;
}
</style>
